import { IS_DEV } from '@/app-config';

export const FEATURE_FLAGS = {
  COPY_INDI_SIGNING_LINK: 'copy-indi-signing-link',
  WORD_EDITOR_REDIRECT: 'word-editor-redirect',
  FRESHCHAT_WIDGET: 'freshchat-widget',
  DYNAMIC_FILENAME: 'dynamic-filename',
  SIGNING_ORDER_DISPLAY: 'signing-order-display',
};

type FeatureFlagKeys = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

const GLOBALLY_ENABLED_FEATURES: Record<string, boolean> = {
  [FEATURE_FLAGS.WORD_EDITOR_REDIRECT]: true,
  [FEATURE_FLAGS.COPY_INDI_SIGNING_LINK]: IS_DEV,
  [FEATURE_FLAGS.FRESHCHAT_WIDGET]: true,
  [FEATURE_FLAGS.DYNAMIC_FILENAME]: IS_DEV,
  [FEATURE_FLAGS.SIGNING_ORDER_DISPLAY]: IS_DEV,
};

const FEATURE_ENABLED_ACCOUNTS: Record<string, number[]> = {
  [FEATURE_FLAGS.COPY_INDI_SIGNING_LINK]: [
    6282335, // jetpackteam
    23847886, // greenwingsmigration
    11768445, // jo-whalley-counselling-services
  ],
  [FEATURE_FLAGS.FRESHCHAT_WIDGET]: [],
  [FEATURE_FLAGS.DYNAMIC_FILENAME]: [
  ],
  [FEATURE_FLAGS.SIGNING_ORDER_DISPLAY]: [],
  [FEATURE_FLAGS.WORD_EDITOR_REDIRECT]: [],
};

export const isFeatureEnabled = (
  feature: FeatureFlagKeys,
  accountId?: string | number,
) => {
  if (!(feature in FEATURE_ENABLED_ACCOUNTS)) {
    return false;
  }

  if (GLOBALLY_ENABLED_FEATURES[feature] === true) {
    return true;
  }

  if (!accountId) {
    return false;
  }

  return FEATURE_ENABLED_ACCOUNTS[feature]?.includes(Number(accountId));
};
